
        import 'TextBox.05a8a17.css-module'
        export default {"textBox":"textBox_TextBox_05a8a17","label":"label_TextBox_05a8a17"}
    